/* eslint-disable @typescript-eslint/no-non-null-assertion */
import type { LinkHref } from "@octopusdeploy/portal-routes";
import { links } from "@octopusdeploy/portal-routes";
import * as React from "react";
import AreaTitle from "~/components/AreaTitle/index";
import type { DataBaseComponentState } from "~/components/DataBaseComponent";
import { DataBaseComponent } from "~/components/DataBaseComponent";
import PaperLayout from "~/components/PaperLayout";
import { useIsPageHeaderVNextEnabled } from "~/components/RootRoutes/useIsPageHeaderVNextEnabled";
import { SkeletonLoadingLayout } from "~/components/SkeletonLoadingLayout/SkeletonLoadingLayout";
import { repository } from "../../clientInstance";
import InternalRedirect from "../../components/Navigation/InternalRedirect/InternalRedirect";
interface DeploymentToProjectTaskRedirectProps {
    spaceId: string;
    deploymentId: string;
}
interface DeploymentToProjectTaskRedirectInternalProps extends DeploymentToProjectTaskRedirectProps {
    isPageHeaderVNextEnabled: boolean;
}
interface DeploymentToProjectTaskRedirectState extends DataBaseComponentState {
    redirectTo: LinkHref;
}
class DeploymentToProjectTaskRedirectInternal extends DataBaseComponent<DeploymentToProjectTaskRedirectInternalProps, DeploymentToProjectTaskRedirectState> {
    constructor(props: DeploymentToProjectTaskRedirectInternalProps) {
        super(props);
        this.state = {
            redirectTo: null!,
        };
    }
    async componentDidMount() {
        await this.doBusyTask(async () => {
            const deploymentId = this.props.deploymentId;
            const deployment = await repository.Deployments.get(deploymentId);
            const release = await repository.Releases.get(deployment.ReleaseId);
            const path = links.deploymentDetailsPage.generateUrl({ spaceId: this.props.spaceId, projectSlug: release.ProjectId, releaseVersion: release.Version, deploymentId: deployment.Id });
            this.setState({
                redirectTo: path,
            });
        });
    }
    render() {
        const redirectTo = this.state.redirectTo;
        if (!redirectTo) {
            return this.props.isPageHeaderVNextEnabled ? (<main>
                    <SkeletonLoadingLayout errors={this.errors}/>
                </main>) : (<main>
                    <AreaTitle link={links.projectsPage.generateUrl({ spaceId: this.props.spaceId })} title="Projects"/>
                    <PaperLayout busy={this.state.busy} fullWidth={true} errors={this.errors} title={`Deployment`}/>
                </main>);
        }
        return <InternalRedirect push={false} to={redirectTo}/>;
    }
    static displayName = "DeploymentToProjectTaskRedirectInternal";
}
export default function DeploymentToProjectTaskRedirect(props: DeploymentToProjectTaskRedirectProps) {
    const isPageHeaderVNextEnabled = useIsPageHeaderVNextEnabled();
    return <DeploymentToProjectTaskRedirectInternal {...props} isPageHeaderVNextEnabled={isPageHeaderVNextEnabled}/>;
}
